import { AnyObject } from "@/types/common";
import { AxiosError } from 'axios';
import { ParsedAxiosError } from '@/types/error';

export const isAxiosError = (error: Error | AxiosError): error is AxiosError => {
  return 'isAxiosError' in error;
};

export const parseAxiosError = (error: Error | AxiosError): ParsedAxiosError | null => {
  if (isAxiosError(error) && error.response?.status === 422) {
    return {
      type: 'validation',
      errors: (error.response?.data as AnyObject)?.errors ?? {},
    };
  }

  return null;
};
